import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
// import VuexPersist from "vuex-persist";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

import user from "@/store/_user";
import layout from "@/store/_layout";
import message from "@/store/_message";
import log from "@/store/_log";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "mmk5_agent_site";

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    user: {
      platformLookUp: state.user.platformLookUp,
      gameTypeLookUp: state.user.gameTypeLookUp,
      leagueLookUp: state.user.leagueLookUp,
      currencyLookup: state.user.currencyLookup,
    },
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize,
      getSportType: state.layout.sportType,
      getLeagueID: state.layout.league,
      getMatchID: state.layout.match
    }
  })
});

const cookieStorage = new VuexPersistence({
  key: storageKey,
  restoreState: (key) => Cookies.getJSON(key),
  saveState: (key, state) =>
  Cookies.set(key, state, {
    expires: 3
  }),
  reducer: state => ({
    user: {
      login: state.user.login,
      account: state.user.account,
      profile: state.user.profile,
      access: state.user.access,
      ptList: state.user.ptList,
      blList: state.user.blList,
      operatorblList: state.user.operatorblList,
      cmList: state.user.cmList,
      platform: state.user.platform,
      selectedID: state.user.selectedID,
      scheduleList: state.user.scheduleList,
      wallet: state.user.wallet,
      tier: state.user.tier,
    }
  })
});

const store = new Vuex.Store({
  modules: {
    user,
    layout,
    message,
    log
  },
  getters: {
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    dateRange: state => {
      return state.layout.dateRange;
    },
    daterange: state => {
      return state.layout.daterange;
    },
    loginID: state => {
      return state.user.login.login_id;
    },
    profileID: state => {
      return state.user.profile.profile_id;
    },
    displayName: state => {
      if(state.user.profile.full_name) {
        return state.user.profile.full_name.replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      } else {
        return null;
      }
    },
    authToken: state => {
      return state.user.login.auth_token;
    },
    isLoggedIn: state => {
      //console.log(state.user)
      if (state.user.login.auth_token) {
        return true;
      } else {
        return false;
      }
    },
    authorityRole: state => {
      return state.user.login.authority_role;
    },
    accessRoles: state => {
      return state.user.access;
    },
    profileStatus: state => {
      return state.user.profile.status;
    },
    accountType: state => {
      //console.log(state.user)
      return state.user.account.account_type;
    },
    securityTag: state => {
      return state.user.profile.security_tag;
    },
    accountStatus: state => {
      return state.user.account.status
    },
    accessOptions: state => {
      return state.layout.accessList;
    },
    accountID: state => {
      return state.user.account.account_id;
    },
    // getCommSB: state => (group) => {
    //   if(state.user.cmList) {
    //     return state.user.cmList[0];
    //   }
    // },
    // getCommSBPackages: state => {
    //   if(state.user.cmList) {
    //     return state.user.cmList[0].hdp_packages;

    //   }
    // },
    getTier: state => {
      return state.user.tier;
    },
    getCommSBPackages: state => {
      console.log(state.user.cmList)
      if(state.user.cmList.Table) {
        return state.user.cmList.Table[0].hdp_packages;
      }
    },
    getCommSB: state => (group) => {
      if(state.user.cmList.Table) {
        return state.user.cmList.Table[0][group];
      }
    },
    getCommMmo: state => (group) => {
      if(state.user.cmList.Table1) {
        return state.user.cmList.Table1[0][group];
      }
    },
    getCommLC: state => {
      // console.log(state.user.cmList)

      if(state.user.cmList.Table3) {
        return state.user.cmList.Table3[0].comm_rate;
      }
    },
    getCommSL: state => {
      // console.log(state.user.cmList)
      if(state.user.cmList.Table2) {
        return state.user.cmList.Table2[0].comm_rate;
      }
    },
    securityDisabled: state => {
      return state.user.profile.security_disabled;
    },
    getSelectedID: state => {
      return state.user.selectedID;
    },
    getGameTypeLookUp: state => {
      return state.user.gameTypeLookUp;
    },
    getLeagueLookUp: state => {
      return state.user.leagueLookUp;
    },
    getBetLimit: state => {
      // console.log(state.user.blList)
      if(state.user.blList.Table) {
        return state.user.blList.Table;
      }
    },
    getBetLimitPackage: state => {
      // console.log(state.user.blList)
      if(state.user.blList.Table1) {
        return state.user.blList.Table1;
      }
    },
    getOperatorBetLimit: state => {
      if(state.user.operatorblList) {
        return state.user.operatorblList;
      }
    },
    getPTSB: state => {
      if(state.user.ptList.Table) {
        return state.user.ptList.Table;
      }
      // if(state.user.ptList.ptSB) {
      //   return state.user.ptList.ptSB;
      // }
    },
    getPTLC: state => {
      if(state.user.ptList.Table2) {
        return state.user.ptList.Table2;
      }
    },
    getPTSL: state => {
      if(state.user.ptList.Table1) {
        return state.user.ptList.Table1;
      }
    },
    getSportType: state => {
      return state.layout.sportType;
    },
    getLeagueID: state => {
      return state.layout.league;
    },
    getMatchID: state => {
      return state.layout.match;
    },
    getPlatform: state => {
      return state.layout.platform;
    },
    getSelectedType: state => {
      return state.user.selectedType;
    },
    getBetListDetail: state => {
      return state.layout.betListDetail;
    },
    getPageDetail: state => {
      return state.layout.pageDetail;
    },
    getAccountCurrency: state => {
      return state.user.account.currency;
    },
    getPlatformLookUp: state => {
      return state.user.platformLookUp;
    },
    getCurrencyLookUp: state => {
      return state.user.currencyLookUp;
    },
    getScheduleList: state => {
      return state.user.scheduleList;
    },
    getPlatformList: state => {
      if (state.user.platform) {
        return state.user.platform;
      }
    },
    cashMode: state => {
      if (state.user.account.system_type)
        return state.user.account.system_type.toUpperCase() == "CASH";

      return null;
    },
    // getCommMmo: state => (group) => {
    //   if(state.user.cmList.cmMMO) {
    //     return state.user.cmList.cmMMO[0][group];
    //   }
    // },
    getCommMMO: state => {
      if(state.user.cmList.Table1) {
        return state.user.cmList.Table1;
      }
    },
    getAccountMemberCreditLimit: state => {
      if (state.user.account.account_type == 7)
        return 900000000000000;

      if(state.user.wallet) {
        return state.user.wallet[0].member_credit_limit;
      }
    },
    getAccountCreditLimit: state => {
      if (state.user.account.account_type == 7)
        return 900000000000000;

      if(state.user.wallet) {
        return state.user.wallet[0].credit_limit;
      }
    },
    getCreditUsedDownline: state => {
      if (state.user.account.account_type == 7)
        return 0;

      if(state.user.wallet) {
        return state.user.wallet[0].used_credit;
      }
      // return state.user.credit_used_downline;
    },
    getAccountCashBalance: state => {
      if(state.user.wallet) {
        return state.user.wallet[0].cash_balance;
      }
    },
    getAccountBalance: state => {
      if(state.user.wallet) {
        return state.user.wallet[0].account_balance;
      }
    },
    getDefaultComm: state => {
      return state.user.defaultComm
    },
    getDefaultBL: state => {
      return state.user.defaultBL
    },
    getDefaultPT: state => {
      return state.user.defaultPT
    },
    getDefaultSchedule: state => {
      return state.user.defaultSchedule
    },
    getDefaultCommSB: state => (group) => {
      if(state.user.defaultComm.Table) {
        return state.user.defaultComm.Table[0][group];
      }
    },
    getDefaultCommMmo: state => (group) => {
      if(state.user.defaultComm.Table1) {
        return state.user.defaultComm.Table1[0][group];
      }
    },
    getDefaultCommLC: state => {
      if(state.user.defaultComm.Table3) {
        return state.user.defaultComm.Table3[0].comm_rate;
      }
    },
    getDefaultCommSL: state => {
      if(state.user.defaultComm.Table2) {
        return state.user.defaultComm.Table2[0].comm_rate;
      }
    },
    getDefaultBetLimit: state => {
      if(state.user.defaultBL.Table) {
        return state.user.defaultBL.Table;
      }
    },
    getDefaultBetLimitPackage: state => {
      // console.log(state.user.defaultBL)
      if(state.user.defaultBL.Table1) {
        return state.user.defaultBL.Table1;
      }
    },
    getDefaultPTSB: state => {
      if(state.user.defaultPT.Table) {
        return state.user.defaultPT.Table;
      }
      // if(state.user.ptList.ptSB) {
      //   return state.user.ptList.ptSB;
      // }
    },
    getDefaultPTLC: state => {
      if(state.user.defaultPT.Table2) {
        return state.user.defaultPT.Table2;
      }
    },
    getDefaultPTSL: state => {
      if(state.user.defaultPT.Table1) {
        return state.user.defaultPT.Table1;
      }
    },
    getSelectedSystemType: state => {
      return state.user.selectedSystemType;
    },
    getSelectedCurrency: state => {
      return state.user.selectedCurrency;
    },
    getRedirectType: state => {
      return state.user.redirectType;
    },
    getSelectedProvider: state => {
      return state.user.selectedProvider;
    },
    getRedirectType: state => {
      return state.user.redirectType;
    },
    isSlotPlatformEnabled: state => {
      if (state.user.platform) {
        // return state.user.platform.platform[1].status;
        return state.user.platform.filter(x => x.game_type == 'SLOTS');
      }
    },
    isLivecasinoPlatformEnabled: state => {
      if (state.user.platform) {
        return state.user.platform.filter(x => x.game_type == 'LIVECASINO');
      }
    }
  },
  // plugins: [cookieStorage.plugin]
  plugins: [localStorage.plugin, cookieStorage.plugin]
});

export default store;
